module.exports = __webpack_public_path__ + "img/banner05.6127d41a.png";